import { render, staticRenderFns } from "./CatalogMapping.vue?vue&type=template&id=e4d1d196"
import script from "./CatalogMapping.vue?vue&type=script&lang=js"
export * from "./CatalogMapping.vue?vue&type=script&lang=js"
import style0 from "./CatalogMapping.vue?vue&type=style&index=0&id=e4d1d196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports